<tmx-nav-dropdown
  *transloco="let t"
  ariaLabel="{{ t('components.switchAccounts.switchAccounts') }}"
  dropdownTooltip="{{ t('components.switchAccounts.switchAccount') }}"
  [disabled]="loading()"
>
  <i
    class="modus-icons text-white notranslate"
    [attr.aria-label]="t('components.switchAccounts.switchAccounts')"
    icon
    aria-hidden="true"
    >switch_account</i
  >

  <div class="d-flex flex-column" style="margin: 0 -12px">
    <h3 class="switch-header border-bottom">
      {{ t('components.switchAccounts.switchAccount') }}
    </h3>
    <div style="padding: 0.5rem 0.75rem 0">
      <div class="d-flex align-items-center p-2">
        <div class="form-control-with-icon flex-grow-1" role="search">
          <input
            class="form-control"
            type="search"
            placeholder="{{ t('components.switchAccounts.searchAccounts') }}"
            aria-label="Search Accounts"
            [formControl]="searchControl"
          />
          <div class="form-control-icon">
            <i
              class="modus-icons notranslate user-select-none"
              aria-hidden="true"
              >search</i
            >
          </div>
        </div>
        <button
          type="button"
          class="btn btn-text-primary ms-2"
          (click)="searchControl.setValue('')"
        >
          {{ t('components.switchAccounts.showAll') }}
        </button>
      </div>
      <div class="content border-top overflow-x-hidden overflow-y-auto">
        @if (partnerAccounts().length > 0) {
          <h6 class="dropdown-header pt-1">
            {{
              t('components.switchAccounts.myAccount', {
                count: partnerAccounts().length,
              })
            }}
          </h6>
          @for (account of partnerAccounts(); track account.value) {
            <a class="dropdown-item" (click)="switch(account.value)">
              <span class="ms-3">{{
                account.displayName | truncateString: 45
              }}</span>
            </a>
          }
        }

        @if (customerAccounts().length > 0) {
          <h6 class="dropdown-header pt-2">
            {{
              t('components.switchAccounts.customerAccount', {
                count: customerAccounts().length,
              })
            }}
          </h6>
          @for (account of customerAccounts(); track account.value) {
            <a class="dropdown-item" (click)="switch(account.value)">
              <span class="ms-3">{{
                account.displayName | truncateString: 45
              }}</span>
            </a>
          }
        }
      </div>
    </div>
  </div>
</tmx-nav-dropdown>
